// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#41485D","menuText":"#bfcbd9"};